export default "__VITE_ASSET__A414sguD__"